export default __webpack_public_path__ + "static/B48-73a49bbe9b407bfd589324c62cabc960.png";